// import React from "react";
// import Button from "@mui/material/Button";

// import Grid from "@mui/material/Grid";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import Typography from "@mui/material/Typography";
// import {useTheme} from "@mui/material/styles";
// import {useTranslation} from "react-i18next";
// import {CircularProgress} from "@mui/material";

// export default function DatasetUpload(props) {
//     const theme = useTheme();
//     // init internationalization
//     const {t} = useTranslation();
//     const [uploadClicked, setUploadClicked] = React.useState(false);

//     const handleButtonClick = (event) => {
//         // simple method to set variable to true after button click to display Spinner
//         setUploadClicked(true);

//         // then call actual file upload method
//         props.handleFileUpload(event);
//     };

//     return (
//         <Grid container>
//             <Grid
//                 id="file-upload-container"
//                 container
//                 spacing={2}
//                 sx={{paddingTop: theme.spacing(6)}}
//             >
//                 <Grid item xs={4} sx={{"li::marker": {content: '""'}}}>
//                     <Typography variant="h5" gutterBottom>
//                         {t("fileUpload.Requirements")}
//                     </Typography>
//                     <br/>
//                     <table>
//                         <tbody>
//                         <tr>
//                             <td>
//                                 <b>{t("fileUpload.FileType")}</b>
//                             </td>
//                             <td>
//                                 <ul>
//                                     <li>.csv</li>
//                                 </ul>
//                             </td>
//                         </tr>
//                         <tr>
//                             <td>
//                                 <b>{t("fileUpload.FileSize")}</b>
//                             </td>
//                             <td>
//                                 <ul>
//                                     <li>Max 1000MB</li>
//                                 </ul>
//                             </td>
//                         </tr>
//                         <tr>
//                             <td>
//                                 <b>{t("fileUpload.NumberRows")}</b>
//                             </td>
//                             <td>
//                                 <ul>
//                                     <li>Min 20, Max 1 000 000</li>
//                                 </ul>
//                             </td>
//                         </tr>
//                         <tr>
//                             <td>
//                                 <b>{t("fileUpload.NumberCols")}</b>
//                             </td>
//                             <td>
//                                 <ul>
//                                     <li>Min 3, Max 10 000</li>
//                                 </ul>
//                             </td>
//                         </tr>
//                         <tr>
//                             <td>
//                                 <b>{t("fileUpload.Encoding")}</b>
//                             </td>
//                             <td>
//                                 <ul>
//                                     <li>{t("fileUpload.EncodingValues")}</li>
//                                 </ul>
//                             </td>
//                         </tr>
//                         <tr>
//                             <td>
//                                 <b>{t("fileUpload.Formatting")}</b>
//                             </td>
//                             <td>
//                                 <ul>
//                                     <li>-{t("fileUpload.FirstRow")}</li>
//                                     <li>-{t("fileUpload.EachCol")}</li>
//                                     <li>-{t("fileUpload.MultiIndexing")}</li>
//                                 </ul>
//                             </td>
//                         </tr>
//                         </tbody>
//                     </table>
//                 </Grid>
//                 <Grid item xs={3}>
//                     <Grid
//                         container
//                         direction="row"
//                         justifyContent="center"
//                         alignItems="center"
//                     >
//                         {!uploadClicked ? (
//                             <label htmlFor="contained-button-file">
//                                 <Button variant="contained" color="primary" component="span">
//                                     {t("fileUpload.UploadCSVButton")} &nbsp;
//                                     <input
//                                         hidden
//                                         accept=".csv"
//                                         id="contained-button-file"
//                                         className="upload-input"
//                                         type="file"
//                                         onChange={handleButtonClick}
//                                     />
//                                     <CloudUploadIcon/>
//                                 </Button>
//                             </label>
//                             ) : (
//                                 <div>
//                                     <CircularProgress/>
//                                     <p>&nbsp;{t("datasetCreator.UploadInProgress")}</p>
//                                 </div>
//                             )}
//                     </Grid>
//                 </Grid>
//             </Grid>
//         </Grid>
//     );
// }

import React from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import StorageIcon from "@mui/icons-material/Storage";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import NumbersIcon from "@mui/icons-material/Numbers";
import CodeIcon from "@mui/icons-material/Code";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

export default function DatasetUpload(props) {
  const theme = useTheme();
  const { t } = useTranslation();
  const [uploadClicked, setUploadClicked] = React.useState(false);

  const handleButtonClick = (event) => {
    setUploadClicked(true);
    props.handleFileUpload(event);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 6 } }}>
      <Grid container spacing={3} justifyContent="center">
        {/* Requirements Card */}
        <Grid item xs={12} md={7}>
          <Card
            sx={{
              p: { xs: 2, md: 3 },
              borderRadius: 3,
              boxShadow: 4,
              minHeight: 360,
            }}
          >
            <Typography
              variant="h5"
              color="primary"
              fontWeight={600}
              gutterBottom
            >
              {t("fileUpload.Requirements")}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <List
              sx={{
                "& .MuiListItem-root:hover": {
                  backgroundColor: "transparent",
                  color: "inherit", // or theme.palette.text.primary
                },
                // for icons inside list items too
                "& .MuiListItem-root:hover .MuiListItemIcon-root": {
                  color: "inherit",
                },
              }}
            >
              <ListItem>
                <ListItemIcon>
                  <InsertDriveFileIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary={`${t("fileUpload.FileType")}: .csv`} />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <StorageIcon sx={{ color: theme.palette.warning.main }} />
                </ListItemIcon>
                <ListItemText
                  primary={`${t("fileUpload.FileSize")}: Max 1000MB`}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <NumbersIcon sx={{ color: theme.palette.info.main }} />
                </ListItemIcon>
                <ListItemText
                  primary={`${t(
                    "fileUpload.NumberRows"
                  )}: Min 20, Max 1,000,000`}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <ViewColumnIcon sx={{ color: theme.palette.success.main }} />
                </ListItemIcon>
                <ListItemText
                  primary={`${t("fileUpload.NumberCols")}: Min 3, Max 10,000`}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <CodeIcon sx={{ color: theme.palette.secondary.main }} />
                </ListItemIcon>
                <ListItemText
                  primary={`${t("fileUpload.Encoding")}: ${t(
                    "fileUpload.EncodingValues"
                  )}`}
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <FormatListBulletedIcon color="action" />
                </ListItemIcon>
                <ListItemText
                  primary={t("fileUpload.Formatting")}
                  secondary={
                    <ul style={{ margin: "8px 0 0 18px", padding: 0 }}>
                      <li>{t("fileUpload.FirstRow")}</li>
                      <li>{t("fileUpload.EachCol")}</li>
                      <li>{t("fileUpload.MultiIndexing")}</li>
                    </ul>
                  }
                />
              </ListItem>
            </List>
          </Card>
        </Grid>
        {/* Upload Section Card */}
        <Grid item xs={12} md={5}>
          {!uploadClicked ? (
            <label htmlFor="contained-button-file">
              <Button
                startIcon={<CloudUploadIcon />}
                variant="contained"
                sx={{
                  borderRadius: 8,

                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  boxShadow: 2,
                  transition: "all 0.2s",
                  "&:hover": {
                    boxShadow: 6,
                    backgroundColor: theme.palette.primary.dark,
                  },
                }}
                component="span"
                aria-label={t("fileUpload.UploadCSVButton")}
              >
                {t("fileUpload.UploadCSVButton")}
                <input
                  hidden
                  accept=".csv"
                  id="contained-button-file"
                  type="file"
                  onChange={handleButtonClick}
                />
              </Button>
            </label>
          ) : (
            <Box sx={{ textAlign: "center" }}>
              <CircularProgress size={40} thickness={6} />
              <Typography
                variant="subtitle1"
                color="secondary"
                sx={{ mt: 2, fontWeight: "bold" }}
              >
                {t("datasetCreator.UploadInProgress")}
              </Typography>
            </Box>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
